<template>
	<div id="visitRecordList">
			<el-form :inline="true" :model="form" label-width="90px" class="clearfix pt-30">
				<div>
					<el-form-item label="拜访时间">
						<ys-daterange-picker v-model="form.timerange" type="date" :endDisabledDate="new Date()" />
					</el-form-item>
					<el-form-item label="店铺名称">
						<el-input placeholder="请输入拜访店铺" v-model.trim="form.name" :disabled="isAdmin == 0 && isDepartmentLeader == 0"></el-input>
					</el-form-item>
					<el-form-item label="拜访类别">
						<el-select v-model="form.actionClassifyId" clearable>
							<el-option :label='item.actionClassifyName' :value="item.id" v-for='item in tableList' :key='item.id'></el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item label="所属区域:">
            <districtSelect v-model="form.districtId" class="mr-10 mb-10"/>
          </el-form-item> -->
					<el-form-item label="销售顾问">
						<el-select v-model="form.managerId" filterable clearable placeholder="请选择销售顾问">
							<el-option :label='item.name' :value="item.managerId" v-for='item in managerList' :key='item.managerId'></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="销售部门">
						<el-select v-model="form.departmentId" filterable clearable>
							<el-option :label='item.text' :value="item.id" v-for='item in departmentsList' :key='item.id'></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div>
					<el-button type="info" class="ml-10" @click="search" icon="el-icon-search">搜 索</el-button>
				</div>
			</el-form>
			<div class="clearfix">
				<el-button class="fr mr-30" type="text" @click="getZipInfo">导出照片</el-button>
				<el-button class="fr mr-30" type="text" @click="exportInfo">导出记录</el-button>
			</div>
			<el-table :data="tableData" v-loading="Loading" class='mt-10 table-default'>
				<el-table-column label="销售顾问" min-width="100">
					<template slot-scope="scope">
						<div>{{scope.row.managerName}}</div>
					</template>
				</el-table-column>
				<el-table-column label="签到时间" min-width="115">
					<template slot-scope="scope">
						<div>{{scope.row.startTime | timeI}}</div>
					</template>
				</el-table-column>
				<el-table-column label="签退时间" min-width="115">
					<template slot-scope="scope">

						<div v-if="scope.row.commitTime">{{scope.row.commitTime | timeI}}</div>
						<div v-else>未签退</div>
					</template>
				</el-table-column>
				<el-table-column label="拜访时长" min-width="90">
					<template slot-scope="scope">
						<div v-if="scope.row.visitDuration">{{scope.row.visitDuration}}</div>
						<div v-else>暂无数据</div>
					</template>
				</el-table-column>
				<el-table-column label="拜访店铺" min-width="120">
					<template slot-scope="scope">
						<div>{{scope.row.traderName}}</div>
					</template>
				</el-table-column>
				<el-table-column label="拜访动作" min-width="60">
					<template slot-scope="scope">
						<div>{{scope.row.actionNumScale}}</div>
					</template>
				</el-table-column>
				<el-table-column label="签到位置" min-width="60">
					<template slot-scope="scope">
						<div>{{scope.row.signOnStatus == 0 ? '异常' : '正常'}}</div>
					</template>
				</el-table-column>
				<el-table-column label="签到偏差距离(米)" min-width="80">
					<template slot-scope="scope">
						<div>{{scope.row.signOnLocation}}</div>
					</template>
				</el-table-column>
				<el-table-column label="签退位置" min-width="60">
					<template slot-scope="scope">
						<div>{{scope.row.commitStatus == 0 ? '异常' : '正常'}}</div>
					</template>
				</el-table-column>
				<el-table-column label="签退偏差距离(米)" min-width="80">
					<template slot-scope="scope">
						<div>{{scope.row.commitLocation}}</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" min-width="100">
					<template slot-scope="scope">
						<el-button @click="toDetail(scope.row.id)" type="text" size="small">查看</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页组件 -->
			<el-pagination class="tar mt-20" :current-page="currentPage" :page-size='10' :total='total' layout="prev , pager, next, jumper" v-if="total>0" @current-change="handlePageChange"></el-pagination>

	</div>
</template>

<script>
	import { axiosApi, basePath } from '~/api/api'
	import { getDepartments, getManagerInfo, getZip } from "~/api/sales";
	import { computeNumber, postExcelFile } from "@/utils";
  import { mapActions, mapMutations } from "vuex";

	// import YsDaterangePicker from "~/components/ys-daterange-picker";
	import districtSelect from "@/components/districtSelect/districtSelect.vue";
	export default {
		components: {districtSelect},
		data() {
			return {
				c:'empty',
				fileName:'拜访记录.xls',
				Loading: false,
				tableData: [],
				form: {
					timerange: [],
					name: '',
					actionClassifyId: null,
					managerId:null,
					departmentId:null
				},
				total: 0,
				currentPage: 1,
				startTime: '',
				endTime: '',
				managerName: '',
				clearable: true,
				a: 0, //固定值 写死
				exportForm: {}, //导出表单
				tableList: [], //分类列表数据
				isDepartmentLeader:null,
				departmentsList:[],
				managerList:[],
			}
		},
		methods: {
      ...mapActions("clientType", ["resolveIsSalesDepartmentLeaderWithCache"]),
			getZipInfo(){
				getZip(this.postData).then(res=>{
						const link = document.createElement('a');
						link.href = res;
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
				}).catch(err=>{

				})
			},
			getSelectionList(){
				this.getManagerList()
				this.getDepartmentsList()
        this.queryVisitAction() //分类数据
			},

			getDepartmentsList(){
				getDepartments().then(res=>{
					this.departmentsList = res
				}).catch(err=>{

				})
			},
			getManagerList(){
				getManagerInfo({sellerId:sessionStorage.traderId}).then(res=>{
					this.managerList = res.elements
				}).catch(err=>{

				})
			},
			handlePageChange(val) {
				this.currentPage = val
				this.getList()
			},
			search() { //提交
        this.currentPage = 1
        this.getList()
			},

      getList(){
        axiosApi('/sales/visitSign/visitSelectPageList', this.postData, res => {
					this.tableData = res.data.data.elements;
					this.total = res.data.data.totalCount; //总条目数量
					this.currentPage = res.data.data.pageIndex;
					this.Loading = false
				},this.currentPage, 10)
      },
			toDetail(id) {
				this.$router.push({
					path: '/customer/visitedDetail?id=' + id
				})
			},
			timeFormat(value) {
				var myDate = new Date(value);
				var year = myDate.getFullYear();
				var month = myDate.getMonth() + 1 < 10 ? '0' + (myDate.getMonth() + 1) : myDate.getMonth() + 1;
				var day = myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate();
				return year + '-' + month + '-' + day;
			},

			exportInfo(){
				let body =  {}
					body = Object.assign({},this.postData)
					body.modelName = 'empty',
					body.startRow = 0
					body.fileName = '拜访记录.xls'
					postExcelFile(body,'/sunrise-gateway/export/sales/web/visitSign')
			},
			queryVisitAction() {
				axiosApi('/sales/visitActionClassify/web/selectList', {
					sellerId: sessionStorage.traderId
				}, res => {
					console.log(res, 'res')
					res.data.data.unshift({
						actionClassifyName:'全部类别',
						id:null						
					})
					this.tableList = res.data.data
				})
			},
		},
		activated() {
			this.$nextTick(() => {
				this.getSelectionList()
				this.search()
			})
		},
		computed: {
			isAdmin() {
				return sessionStorage.getItem('isAdmin')
			},
			postData() {
				this.startTime = Date.parse(this.form.timerange[0])
				this.endTime = Date.parse(this.form.timerange[1])
				this.startTime = this.timeFormat(this.startTime);
				this.endTime = this.timeFormat(this.endTime);
				return {
					startTime: this.startTime == 'NaN-NaN-NaN' ? '' : this.startTime,
					endTime: this.endTime == 'NaN-NaN-NaN' ? '' : this.endTime,
					fuzzyText: this.form.name,
					actionClassifyId:this.form.actionClassifyId,
					managerId:this.form.managerId,
					departmentId:this.form.departmentId
				}
			}
		},
		mounted(){
			this.getSelectionList();
      this.search()
			this.resolveIsSalesDepartmentLeaderWithCache(res=>{
					console.log(res)
					this.isDepartmentLeader = res
			});
		}
	}
</script>

<style lang="less">
	#visitRecordList {

		.border {
			border: 1px solid #EEEEEE;
			background-color: #EEEEEE;
		}
		.inputWidth {
			width: 170px;
		}
	}
</style>